export enum EstadoSolicitudAntigua {
    PENDING = 1,
    DEVOLUTION = 2,
    APPROBATION = 3,
    DUPLICIDAD = 4,
    BLOQUEO_SAP = 5,
    APROBADO_PARCIAL = 6,
    APROBADO_MANUAL = 7,
    ACTUALIZACION_OPERATIVA = 8,
    RECHAZADO = 9
}